import { PaymentMethodResponse } from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const GET_PAYMENT_METHOD = '/api/payments/payment-method';

export const getPaymentMethod = async (
  apiFetch: APIFetch,
  paymentMethodID: string,
  buyerId: string
): Promise<HandlerResponse<PaymentMethodResponse>> => {
  const uri = `${GET_PAYMENT_METHOD}/${paymentMethodID}?scopeID.eq=${buyerId}&scopeType.eq=BUYER`;
  const res: APIResponse<PaymentMethodResponse> =
    await apiFetch<PaymentMethodResponse>(
      uri,
      { method: 'GET' },
      PaymentMethodResponse
    );

  return handleResponse(res);
};
